// extracted by mini-css-extract-plugin
export default {"container":"Driver_Orders_container__ld1X1"};